import { OrderedMap, List, Set as ImmutableSet } from 'immutable';
export const INTEGER_PROPERTIES = ImmutableSet(['hs_expiration_date', 'hs_payment_date', 'hs_esign_date', 'hs_createdate', 'hs_lastmodifieddate']);
export const BOOLEAN_PROPERTIES = ImmutableSet(['hs_show_signature_box', 'hs_show_countersignature_box', 'hs_payment_enabled', 'hs_esign_enabled', 'hs_locked']);
export const DEFAULT_QUOTE_ASSOCIATED_OBJECTS = {
  additionalFees: List(),
  lineItems: List(),
  quoteSigners: List(),
  contactSigners: List(),
  userSigners: List(),
  recipientCompany: null,
  quoteBillingCompany: null,
  recipientContacts: List(),
  paymentSchedule: null,
  quoteTemplate: null,
  quoteDocuments: List(),
  quoteBillingContact: null
};
export const QUOTE_ASSOCIATIONS = {
  QUOTE_TO_DEAL: 'QUOTE_TO_DEAL',
  QUOTE_TO_LINE_ITEM: 'QUOTE_TO_LINE_ITEM',
  QUOTE_TO_CONTACT: 'QUOTE_TO_CONTACT',
  QUOTE_TO_COMPANY: 'QUOTE_TO_COMPANY',
  QUOTE_TO_BILLING_COMPANY: 'QUOTE_TO_BILLING_COMPANY',
  QUOTE_TO_QUOTE_TEMPLATE: 'QUOTE_TO_QUOTE_TEMPLATE',
  QUOTE_TO_PAYMENT_SCHEDULE: 'QUOTE_TO_PAYMENT_SCHEDULE',
  QUOTE_TO_QUOTE_DOCUMENT: 'QUOTE_TO_QUOTE_DOCUMENT',
  QUOTE_TO_BILLING_CONTACT: 'QUOTE_TO_BILLING_CONTACT'
};
export const CONTACT_RECORD_TO_SENDER_CONTACT_MAP = OrderedMap({
  firstname: 'hs_sender_firstname',
  lastname: 'hs_sender_lastname',
  email: 'hs_sender_email',
  jobtitle: 'hs_sender_jobtitle',
  phone: 'hs_sender_phone'
});
export const COMPANY_RECORD_TO_SENDER_COMPANY_MAP = OrderedMap({
  name: 'hs_sender_company_name',
  domain: 'hs_sender_company_domain',
  address: 'hs_sender_company_address',
  address2: 'hs_sender_company_address2',
  city: 'hs_sender_company_city',
  zip: 'hs_sender_company_zip',
  state: 'hs_sender_company_state',
  country: 'hs_sender_company_country',
  imageUrl: 'hs_sender_company_image_url'
});

/**
 * HubSpot-defined properties that should be read-only for CPQ/CQT quotes
 * from the perspective of the CRM index page and sidebar.
 * All other HubSpot-defined properties remain editable for these quote types
 * when the quote is not considered locked.
 */
export const READ_ONLY_QUOTE_PROPERTIES = new Set(['hs_status', 'hs_template_type', 'hs_locked', 'hs_esign_enabled']);

/**
 * Status values that allow a CPQ/CQT quote to be edited from the CRM index
 * page and sidebar.
 * All other status values are considered locked or read-only.
 */
export const EDITABLE_QUOTE_STATUS_VALUES = new Set(['DRAFT']);